import { Loader } from "@circle-react-uikit/Loader";
import { CurrentPostContextProvider } from "@circle-react/contexts/currentPostContext";
import { CurrentSpaceContextProvider } from "@circle-react/contexts/currentSpaceContext";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";

import { isImagePost } from "@/react/helpers/postHelpers";
import { usePostResource } from "@/react/hooks/posts/usePostResource";
import type { ImagePost } from "@/react/types";

import { Carousel } from "./Carousel";

export const StandaloneCarousel = ({ postSlug, spaceId }: any) => {
  const { isInitialLoading: isLoading, post: fetchedPost } = usePostResource({
    spaceId,
    postSlug,
  });
  const post: ImagePost | undefined = isImagePost(fetchedPost)
    ? fetchedPost
    : undefined;
  if (isLoading || !post) return <Loader />;
  return (
    <CurrentSpaceContextProvider spaceId={spaceId}>
      <PostsDetailsContextProvider perPagePostIds={[[post.id]]}>
        <CurrentPostContextProvider post={post}>
          <Carousel />
        </CurrentPostContextProvider>
      </PostsDetailsContextProvider>
    </CurrentSpaceContextProvider>
  );
};
